import type { ModuleManifest } from '../types.js'

/**
 * Цаг бүртгэл — ирц, чөлөө.
 *
 * Эх систем (cloud.maximus.mn) дээрх урсгалыг бүрэн давтана:
 *
 *   Түүхий цохилт → өдрийн тайлан → сарын хүснэгт
 *   zkteco төхөөрөмжийн файл + гар утасны апп → нэгтгэсэн ирц
 *   Чөлөөний хүсэлт: pending → manager_approved → hr_approved | rejected | cancelled
 *
 * ! Ирцийн ТАЙЛАН нь түүхий цохилтоос БОДОГДДОГ (`AttendanceService`). Цохилт
 * ! нэмэгдэх бүрд тухайн өдрүүдийн тайланг дахин бодох ёстой — эс тэгвэл сарын
 * ! хүснэгт хуучин утгаа харуулна.
 */
export const timesheetModule = {
  key: 'timesheet',
  name: 'Цаг бүртгэл',
  description: 'Ирцийн сарын хүснэгт, төхөөрөмжийн файл татах, чөлөөний хүсэлт.',
  version: '1.0.0',
  icon: 'ClockIcon',

  permissions: [
    /*
     * ӨӨРИЙН ирц — бүх дүрд олгогдоно. `timesheet.attendance:list` нь БҮХ
     * ажилтны ирцийг нээдэг тул үүнийг тусад нь зарлав: хүн өөрийн ирцээ
     * харахын тулд бусдынхыг харах эрх авах ёсгүй.
     */
    { resource: 'timesheet.self', action: 'show', description: 'Миний ирц' },

    /*
     * ! ӨӨРИЙН ИРЦ БҮРТГЭХ — GPS-ээр. `timesheet.attendance:manage` нь бусдын
     * ! ирцийг засах АДМИН эрх тул ажилтанд ОГТ өгөхгүй.
     */
    { resource: 'timesheet.self', action: 'attendance', description: 'Өөрийн ирц бүртгэх (GPS)' },

    { resource: 'timesheet.attendance', action: 'list', description: 'Ирцийн хүснэгт харах' },
    { resource: 'timesheet.attendance', action: 'manage', description: 'Ирц засах, төхөөрөмжийн файл татах' },
    { resource: 'timesheet.leave', action: 'list', description: 'Чөлөөний хүсэлт харах' },
    { resource: 'timesheet.leave', action: 'create', description: 'Чөлөө хүсэх' },
    { resource: 'timesheet.leave', action: 'manage', description: 'Чөлөөний хүсэлт батлах, татгалзах' },
  ],

  navigation: [
    {
      label: 'Цаг бүртгэл',
      items: [
        {
          label: 'Ирцийн хүснэгт',
          href: '/timesheet/monthly',
          icon: 'CalendarCheckIcon',
          iconClassName: 'text-emerald-600 dark:text-emerald-400',
          permission: 'timesheet.attendance:list',
        },
        {
          label: 'Чөлөөний хүсэлт',
          href: '/timesheet/leave-requests',
          icon: 'PlaneIcon',
          iconClassName: 'text-amber-600 dark:text-amber-400',
          permission: 'timesheet.leave:list',
        },
        {
          /*
           * Амралтын өдөр — улсын баяр, компанийн амралт.
           *
           * ! `manage` эрх шаардана. Уншихад `list` хангалттай ч энэ нь
           * ! ТОХИРГООНЫ дэлгэц: ирцийн тоог өөрчилдөг тул засах эрхгүй хүнд
           * ! үзүүлэх нь төөрөгдүүлнэ.
           */
          label: 'Амралтын өдөр',
          href: '/timesheet/holidays',
          icon: 'PartyPopperIcon',
          iconClassName: 'text-rose-600 dark:text-rose-400',
          permission: 'timesheet.attendance:manage',
        },
        {
          label: 'Ирц татах',
          href: '/timesheet/upload',
          icon: 'UploadIcon',
          iconClassName: 'text-muted-foreground',
          permission: 'timesheet.attendance:manage',
        },
      ],
    },
  ],

  resources: [
    { name: 'timesheet.attendance', label: 'Ирц', list: '/timesheet/monthly' },
    {
      name: 'timesheet.leave',
      label: 'Чөлөөний хүсэлт',
      list: '/timesheet/leave-requests',
      show: '/timesheet/leave-requests/:id',
    },
  ],
} as const satisfies ModuleManifest
